import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

export default universal(
    universalImport({
        chunkName: () => 'FreestarAdLazy',
        path: () => path.join(__dirname, './FreestarAd'),
        resolve: () => require.resolveWeak('./FreestarAd'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "FreestarAdLazy" */ './FreestarAd')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout: 60000,
    }
);
